const DOM = Object.freeze({
  accordionButtonSelector: '[data-accordion-button]',
});

const handleAccordionButtonClick = button => {
  const textContainerSelector = button.getAttribute('aria-controls');

  if (!textContainerSelector) return;

  const textContainer = document.getElementById(textContainerSelector);

  if (button.getAttribute('aria-expanded') == 'false') {
    button.setAttribute('aria-expanded', true);
    textContainer.setAttribute('aria-hidden', false);
  } else {
    button.setAttribute('aria-expanded', false);
    textContainer.setAttribute('aria-hidden', true);
  }
};

function accordion() {
  const accordionButtons = document.querySelectorAll(
    DOM.accordionButtonSelector,
  );

  if (accordionButtons.length) {
    [...accordionButtons].forEach(button => {
      button.addEventListener('click', function () {
        handleAccordionButtonClick(button);
      });
    });
  }
}

export { accordion };
